module.exports = __webpack_public_path__ + "img/123.3cea46bd.png";